import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { KEY_CONTENT_ROUTES } from 'routing';
import AnimatedContainer from 'components/AnimatedContainer';
import VideoPlayer from 'components/VideoPlayer';
import css from './Video.module.scss';

function Video() {
  return (
    <AnimatedContainer className={css.wrapper}>
      <div className="container">
        <div className={css.Row}>
          <div className={css.columnLeft}>
            <h2 className={css.title}>
              Top quality tutors at affordable prices
            </h2>
            <div className={css.trustedBtns}>
              <a href={KEY_CONTENT_ROUTES.SEARCH_RESULTS} rel="noopener noreferrer" className={cn("btn-home", css.findTutorBtn)}>
                Find a tutor
              </a>
              <Link
                to={KEY_CONTENT_ROUTES.TEACH_WITH_US}
                className="btn-primary"
              >
                Become a Tutor
              </Link>
            </div>
          </div>
          <div className={css.videoContainer}>
            <div className={css.videoPlayer}>
              <VideoPlayer
                src="https://tutorhouse-web-production.s3.eu-west-2.amazonaws.com/videos/Welcome_to_Tutor_House.mp4"
                previewVideo="https://tutorhouse-web-production.s3.eu-west-2.amazonaws.com/videos/Welcome_to_Tutor_House_preview.mp4"
              />
            </div>
          </div>
        </div>
      </div>
    </AnimatedContainer>
  );
}

export default Video;
